/**
 * Human-readable byte size, e.g. `formatBytes(1536)` → `'1.5 KB'`.
 */
export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Locale date+time string for a Cloudinary timestamp.
 */
export const formatDate = (dateString: string): string => new Date(dateString).toLocaleString();
